import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as terminalTransactionActions from '../actions/terminal-transactions.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwTerminalTransactionsApiService } from 'app/services/terminal-transactions-api.service';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class TerminalTransactionEffects {
  loadTerminalTransactions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(terminalTransactionActions.loadTerminalTransactions),
      switchMap(({ loadOptions }) =>
        this.terminalTransactionsApiService
          .gerTerminalTransactions(loadOptions)
          .pipe(
            map((response) =>
              terminalTransactionActions.loadTerminalTransactionsSuccess({
                response,
              })
            ),
            catchError((error) =>
              of(
                terminalTransactionActions.loadTerminalTransactionsFailure({
                  error,
                })
              )
            )
          )
      )
    )
  );

  updateTerminalTransaction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(terminalTransactionActions.updateTerminalTransaction),
      switchMap(({ terminalTransaction }) =>
        this.terminalTransactionsApiService
          .updateTerminalTransaction(terminalTransaction)
          .pipe(
            switchMap((response) => [
              terminalTransactionActions.updateTerminalTransactionSuccess(
                response
              ),
              notifyActions.notifySuccess({
                notification: {
                  phrase: 'OPERATION.edit_terminal_transaction_successful',
                },
              }),
            ]),
            catchError((error) =>
              of(
                terminalTransactionActions.updateTerminalTransactionFailure({
                  error,
                })
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private terminalTransactionsApiService: MwTerminalTransactionsApiService
  ) {}
}
